import React from 'react';
import ProjectContent from '../components/ProjectContent';

const UserLoginDatabase = () => <ProjectContent projectName='User Login Database'/>;

export default UserLoginDatabase;